KROWN.themeName = 'Highlight';
KROWN.themeVersion = '3.2.0';

document.documentElement.style.setProperty('--grid-perfect-width', document.documentElement.clientWidth + 'px');
window.addEventListener('resize', ()=>{
  document.documentElement.style.setProperty('--grid-perfect-width', document.documentElement.clientWidth + 'px');
});

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  document.querySelectorAll('.css-slider, .product-variant__input, .simple-arrow, .mount-header [tabindex]').forEach(elm=>{
    elm.addEventListener('blur', e=>{
      e.currentTarget.classList.remove('focus');
    })
  });

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('css-slider') ||
        e.target.classList.contains('product-variant__input') ||
        e.target.classList.contains('simple-arrow') || 
        e.target.getAttribute('tabindex') != '-1'
      ) {
        e.target.classList.add('focus');
      }
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
				document.querySelector('[data-header-cart-count]').textContent = cartItems.querySelector('[data-cart-count]').textContent;

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				document.getElementById('site-cart-sidebar').show();

		})

	}
}


const quantitySelectorUpdate = () => {
  document.querySelectorAll('.quantity-selector').forEach((selector) => {
    const minusBtn = selector.querySelector('.minus');
    const plusBtn = selector.querySelector('.plus');
    const input = selector.querySelector('.product__quantity');
    const quantityChangeEvent = new Event('quantityChange');

    minusBtn.addEventListener('click', () => {
      let value = parseInt(input.value);
      if (value > 1) {
        value--;
        input.value = value;
        input.dispatchEvent(quantityChangeEvent);
      }
    });

    plusBtn.addEventListener('click', () => {
      let value = parseInt(input.value);
      value++;
      input.value = value;
      input.dispatchEvent(quantityChangeEvent);
    });
  });
};


document.addEventListener('DOMContentLoaded', () => {
  quantitySelectorUpdate();
});


window.addEventListener('quick-view-product-built', (e) => {
  quantitySelectorUpdate();
});


const initializePriceUpdate = () => {
  const priceOriginal = document.querySelectorAll('[data-js-product-price-original]');
  const priceCompare = document.querySelectorAll('[data-js-product-price-compare]');
  const quantitySelector = document.querySelector('.quantity-selector');
  const discountQuantityEl1 = quantitySelector?.getAttribute('data-discount_quantity_1');
  const discountQuantity1 = discountQuantityEl1 ? parseInt(discountQuantityEl1, 10) : null;
  const percentageDiscountEl1 = quantitySelector?.getAttribute('data-percentage_discount_1');
  const percentageDiscount1 = percentageDiscountEl1 ? parseInt(percentageDiscountEl1, 10) : null;
  const discountQuantityEl2 = quantitySelector?.getAttribute('data-discount_quantity_2');
  const discountQuantity2 = discountQuantityEl2 ? parseInt(discountQuantityEl2, 10) : null;
  const percentageDiscountEl2 = quantitySelector?.getAttribute('data-percentage_discount_2');
  const percentageDiscount2 = percentageDiscountEl2 ? parseInt(percentageDiscountEl2, 10) : null;
  
  const priceBadges = document.querySelectorAll('.discount-badge');

  const convertToEuro = (cents, position = 'after') => {
    let euros = (cents / 100).toFixed(2).replace('.', ',');
    return position === 'before' ? `€${euros}` : `${euros}€`;
  };

  
  const updatePrice = (quantity, variantPrice) => {
    const pricePerItemEl = quantitySelector?.getAttribute('data-price-per-item');
    let pricePerItem = pricePerItemEl ? parseFloat(pricePerItemEl, 10) : null;
    if (variantPrice){
      pricePerItem = variantPrice
    }

    let discount = 0;
    if (quantity >= discountQuantity2) {
      discount = percentageDiscount2;
    } else if (quantity >= discountQuantity1) {
      discount = percentageDiscount1;
    }

    const newPrice = pricePerItem * (1 - discount / 100);

    if (priceOriginal) {
      priceOriginal.forEach((price) => {
        price.innerHTML = convertToEuro(newPrice, 'before');
      });

      if (pricePerItem > newPrice) {
        priceCompare.forEach((price) => {
          price.innerHTML = convertToEuro(pricePerItem, 'before');
        });
      } else {
        priceCompare.forEach((price) => {
          price.innerHTML = '';
        });
      }
    }

    priceBadges.forEach((priceBadge) => {
      if (priceBadge && discount > 0) {
        priceBadge.innerHTML = `${discount}% Rabatt`;
        priceBadge.style.display = 'inline-block';
      } else {
        priceBadge.style.display = 'none';
      }
    });
  };

  if (quantitySelector && discountQuantity1 !== null && percentageDiscount1 !== null) {
    document.querySelectorAll('.product__quantity').forEach((input) => {
      input.addEventListener('quantityChange', () => {
        const quantity = parseInt(input.value);
        if (!isNaN(quantity)) {
          updatePrice(quantity);
        }
      });
    });
  }

  window.addEventListener('variant:variantChange', function(event) {
    const currentVariantPrice = event.detail.currentVariant.price;
    const currentQTY = document.querySelector('.product__quantity').value;
    const currentQtyNum = currentQTY ? parseInt(currentQTY, 10) : null;
    document.querySelector('.quantity-selector').setAttribute('data-price-per-item', currentVariantPrice)
    updatePrice(currentQtyNum, currentVariantPrice);
  });

  document.querySelectorAll('.product__quantity').forEach((input) => {
    input.addEventListener('input', () => {
      const currentQTY = input.value;
      const currentQtyNum = currentQTY ? parseInt(currentQTY, 10) : null;
      updatePrice(currentQtyNum);
    });
  });
};


document.addEventListener('DOMContentLoaded', () => {
  initializePriceUpdate();
});

window.addEventListener('quick-view-product-built', () => {
  initializePriceUpdate();
});
